// import React, { useState } from 'react';
// import './LeftSideNavaBarAdmin.css';
// import { ChevronDown, ChevronUp } from 'lucide-react';
// import { RiDashboardHorizontalFill } from "react-icons/ri";
// import { FaBox } from "react-icons/fa";
// import { IoPricetagsSharp } from "react-icons/io5";
// import { MdOutlineInventory } from "react-icons/md";
// const LeftSideNavBarAdmin = () => {
//   const [openSections, setOpenSections] = useState({
//     productManagement: false,
//     category: false,
//     inventory: false
//   });

//   const toggleSection = (section) => {
//     setOpenSections(prev => ({
//       ...prev,
//       [section]: !prev[section]
//     }));
//   };

//   return (
//     <div className="admin-sidebar">
//       <div className="sidebar-nav">
//         <div className="nav-section">
//           <a href="/AdminDashBoard" className="nav-link">
//             <span className="icon"><RiDashboardHorizontalFill /></span>
//             Dashboard
//           </a>
//         </div>

//         <div className="nav-section">
//           <button
//             className="nav-link"
//             onClick={() => toggleSection('productManagement')}
//           >
//             <span className="icon"><FaBox /></span>
//             Product Management
//             <span className="dropdown-arrow">
//               {openSections.productManagement ? <ChevronUp /> : <ChevronDown />}
//             </span>
//           </button>
//           {openSections.productManagement && (
//             <div className="dropdown-content">
//               <a href="/Product">Add Product</a>
//               <a href="/stockmanagement">Manage Products</a>
//             </div>
//           )}
//         </div>

//         <div className="nav-section">
//           <button
//             className="nav-link"
//             onClick={() => toggleSection('category')}
//           >
//             <span className="icon"><IoPricetagsSharp /></span>
//             Category
//             <span className="dropdown-arrow">
//               {openSections.category ? <ChevronUp /> : <ChevronDown />}
//             </span>
//           </button>
//           {openSections.category && (
//             <div className="dropdown-content">
//               <a href="/Category">Add Category</a>
//               <a href="/EditCategory">Edit Category</a>
//               <a href="/ProductName">Product Names</a>
//             </div>
//           )}
//         </div>

//         <div className="nav-section">
//           <button
//             className="nav-link"
//             onClick={() => toggleSection('inventory')}
//           >
//             <span className="icon"><MdOutlineInventory /></span>
//             Inventory
//             <span className="dropdown-arrow">
//               {openSections.inventory ? <ChevronUp /> : <ChevronDown />}
//             </span>
//           </button>
//           {openSections.inventory && (
//             <div className="dropdown-content">
//               <a href="/AdminOrders">Stock Management</a>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeftSideNavBarAdmin;

import React, { useState } from 'react';
import { MdOutlineMenuOpen } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import './LeftSideNavaBarAdmin.css';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { RiDashboardHorizontalFill } from "react-icons/ri";
import { FaBox } from "react-icons/fa";
import { IoPricetagsSharp } from "react-icons/io5";
import { MdOutlineInventory } from "react-icons/md";
import { MdBorderColor } from "react-icons/md";

const LeftSideNavBarAdmin = () => {
  const [openSections, setOpenSections] = useState({
    productManagement: false,
    category: false,
    inventory: false,
  });

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <>
      {/* Mobile toggle button */}
      <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
        <MdOutlineMenuOpen />
      </button>

      <div
        className={`admin-sidebar ${isSidebarOpen ? 'mobile-visible' : 'mobile-hidden'
          }`}
      >
        <div className="sidebar-nav">
          <button onClick={toggleSidebar} className='closebuttonadmin'>
            <IoClose size={28} />
          </button>
          <div className="nav-section">

            <a href="/AdminDashBoard" className="nav-link">
              <span className="icon">
                <RiDashboardHorizontalFill />
              </span>
              Dashboard
            </a>
          </div>

          <div className="nav-section">
            <button
              className="nav-link"
              onClick={() => toggleSection('productManagement')}
            >
              <span className="icon">
                <FaBox />
              </span>
              Product Management
              <span className="dropdown-arrow">
                {openSections.productManagement ? <ChevronUp /> : <ChevronDown />}
              </span>
            </button>
            {openSections.productManagement && (
              <div className="dropdown-content">
                <a href="/Product">Add Product</a>
                <a href="/stockmanagement">Manage Products</a>
              </div>
            )}
          </div>

          <div className="nav-section">
            <button
              className="nav-link"
              onClick={() => toggleSection('category')}
            >
              <span className="icon">
                <IoPricetagsSharp />
              </span>
              Category
              <span className="dropdown-arrow">
                {openSections.category ? <ChevronUp /> : <ChevronDown />}
              </span>
            </button>
            {openSections.category && (
              <div className="dropdown-content">
                <a href="/Category">Add Category</a>
                <a href="/EditCategory">Edit Category</a>
                {/*   <a href="/ProductName">Product Names</a> */}
              </div>
            )}
          </div>

          <div className="nav-section">
                <a href="/AdminOrders" className="nav-link"> <span className="icon"><MdBorderColor/> </span>Order Management</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftSideNavBarAdmin;
